<template>
  <div>
    <WdsSelect
      v-model="selected"
      multi-select
      searchable
      :list="list"
      :disabled="disabled"
      :error="error"
    >
      <template #label>
        {{ label }}
        <span v-if="required" class="required-asterix">*</span>
        <CustomFieldVisibilityBadge
          v-if="appliesToJob"
          :applies-to="TypeSupportingCustomFieldValues.Job"
          :shared-with-clients="sharedWithClients ?? false"
          :shared-with-staffing-agencies="sharedWithStaffingAgencies ?? false"
          :managed-elsewhere="managedElsewhere"
          :owner-account-name="ownerAccountName"
        />
        <WdsText v-if="description" secondary>{{ description }}</WdsText>
      </template>
    </WdsSelect>
    <input
      v-for="item in selected"
      :key="item.value"
      type="hidden"
      :name="inputName"
      :value="item.value"
    />
    <input v-if="selected.length === 0" type="hidden" :name="inputName" value="" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, inject } from 'vue'
import { WdsSelect, WdsText } from '@worksome/wds-components'
import { TypeSupportingCustomFieldValues } from '@/gql/graphql'
import CustomFieldVisibilityBadge from '@/components/Fieldable/CustomFieldVisibilityBadge.vue'

const props = defineProps<{
  list: { value: string; label: string }[]
  initialValues: { value: string; label: string }[]
  inputName: string
  label: string
  description?: string
  required?: boolean
  disabled?: boolean
  error?: string
  appliesToJob?: boolean
  sharedWithClients?: boolean
  sharedWithStaffingAgencies?: boolean
  managedElsewhere?: boolean
  ownerAccountName?: string | null
}>()

const updateCustomFieldsDependency = inject<(key: string, changed: boolean) => void>(
  'updateCustomFieldsDependency',
)

const selected = ref<{ value: string; label: string }[]>([...props.initialValues])

const initialIds = new Set(props.initialValues.map((v) => v.value))

watch(selected, (newVal) => {
  if (!updateCustomFieldsDependency) return
  const currentIds = new Set(newVal.map((v) => v.value))
  const changed =
    currentIds.size !== initialIds.size || [...currentIds].some((id) => !initialIds.has(id))
  updateCustomFieldsDependency(props.inputName, changed)
})
</script>
